import { LayoutSize } from './types';

export const COMPONENT_SMALL_SIZE_CLASS = 'small';

export const getLayoutClass = (size: LayoutSize) => (size === LayoutSize.SMALL ? COMPONENT_SMALL_SIZE_CLASS : '');
